module.exports = __webpack_public_path__ + "img/lg_ring_y_s_0_1@3x.67681b11.png";